// External library
import { Modal } from 'bootstrap' // eslint-disable-line no-unused-vars

// Component
export default class Announcement {
    constructor () {
        this.announcements = document.querySelectorAll('[data-announcement]') // announcement selector
        this.showCss = 'announcement-show'

        // If there's no announcement, return
        if (!this.announcements)
            return

        if (!this.storage)
            this.storage = {}

        this.announcements.forEach(el => this.loadAnnouncements(el))
    }

    get storage () {
        return JSON.parse(
            window.localStorage.getItem('announcementsDismiss')
        )
    }

    set storage (value) {
        window.localStorage.setItem(
            'announcementsDismiss',
            JSON.stringify(value)
        )
    }

    loadAnnouncements (el) {
        const delay = parseInt(el.dataset.announcementDelay ?? 0)
        const showCss = this.showCss
        const { announcement: type, announcementUpdated: updated } = el.dataset
        const isModal = el.classList.contains('modal')
        const eventType = isModal
            ? 'hide.bs.modal'
            : 'click'

        if (this.storage[type]
            && this.storage[type] === updated
        )
            return

        if (isModal)
            new Modal(el).show()
        else
            setTimeout(function () {
                el.classList.add(showCss)
            }, delay * 1000)

        el.addEventListener(
            eventType,
            this.dismiss.bind(this)
        )
    }

    dismiss (e) {
        const target = e.target
        const wrapper = target.closest('[data-announcement]')
        const { announcement: type, announcementUpdated: updated } = wrapper.dataset

        if (target.closest('[data-announcement-dismiss]')
            || e.type === 'hide.bs.modal'
        ) {
            const current = this.storage

            if (!current[type]
                || current[type] !== updated
            ) {
                current[type] = updated
                this.storage = current
                wrapper.classList.remove(this.showCss)
            }
        }
    }
}
